import type React from "react";

import styled from "styled-components";

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const LOGIN_CONTAINER_WIDTH = 480;

export const LoginContainer: React.FC<Props> = ({ children, className }) => {
  return <Container className={className}>{children}</Container>;
};

const Container = styled.div`
  overflow: hidden;
  box-sizing: border-box;
  max-width: ${LOGIN_CONTAINER_WIDTH}px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  gap: 32px;
  background-color: ${props => props.theme.colors.white};
  border-radius: 12px;
  padding: 32px;

  ${props => props.theme.belowBreakpoint} {
    min-height: 500px;
    border-radius: 0;
  }
`;
